import { callGetDungeonShopConfig } from "@/cloud/game-callables";
import {
  createDefaultDungeonShopConfig,
  normalizeDungeonShopConfig,
  type DungeonShopConfig,
} from "@/dungeon/dungeon-shop-types";

const LOCAL_KEY = "mind-survival/dungeon-shop-config/v1";

let cache: DungeonShopConfig | null = null;

export function loadDungeonShopConfigCached(): DungeonShopConfig {
  if (cache) return cache;
  try {
    const raw = localStorage.getItem(LOCAL_KEY);
    if (raw) {
      cache = normalizeDungeonShopConfig(JSON.parse(raw));
      return cache;
    }
  } catch {
    localStorage.removeItem(LOCAL_KEY);
  }
  cache = createDefaultDungeonShopConfig();
  return cache;
}

export async function hydrateDungeonShopConfig(): Promise<DungeonShopConfig> {
  try {
    const res = await callGetDungeonShopConfig();
    const config = normalizeDungeonShopConfig(res.config);
    cache = config;
    localStorage.setItem(LOCAL_KEY, JSON.stringify(config));
    return config;
  } catch {
    return loadDungeonShopConfigCached();
  }
}

export function saveDungeonShopConfigLocal(config: DungeonShopConfig): void {
  cache = config;
  localStorage.setItem(LOCAL_KEY, JSON.stringify(config));
}
